import { useCallback } from 'react'
import { FormDialog } from 'components/dialog/form'
import { InviteResult } from 'interface/user/invite'
import { InviteRejectForm, useInviteRejectForm } from '../form/reject'
import { Alert, AlertTitle } from '@mui/material'

type InviteRejectDialogProps = {
  invite: InviteResult
  onRejectInvite: (inviteId: number) => void
  onClose: () => void
}
export const InviteRejectDialog = ({
  invite,
  onRejectInvite,
  onClose
}: InviteRejectDialogProps) => {
  const onSubmit = useCallback(
    (inviteId: number) => {
      onRejectInvite(inviteId)
      onClose()
    },
    [onClose, onRejectInvite]
  )
  const form = useInviteRejectForm({ invite, onSubmit })
  return (
    <FormDialog
      open
      fullWidth
      maxWidth="sm"
      title="招待申請を却下"
      note={(
        <Alert severity="info">
          <AlertTitle>招待申請を却下します</AlertTitle>
          メールで通知する内容を指定できます。
        </Alert>
      )}
      isLoading={form.postState.posting}
      error={form.postState.error}
      body={<InviteRejectForm {...form}/>}
      submitLabel="却下"
      isValid={form.formState.isValid}
      onSubmit={form.submit}
      onClose={onClose}
    />
  )
}
